module.exports = __webpack_public_path__ + "static/media/xmas.fdb596d9.svg";